import { render, staticRenderFns } from "./ReceiptPresentation.vue?vue&type=template&id=8315a900&scoped=true&"
import script from "./ReceiptPresentation.vue?vue&type=script&lang=js&"
export * from "./ReceiptPresentation.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPresentation.vue?vue&type=style&index=0&id=8315a900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8315a900",
  null
  
)

export default component.exports